import { useEffect, useState } from 'react';
import { useListResultsQuery } from '../../../api/result';
import { useCappedPolling } from '../../../hooks/useCappedPolling';

// Analysis runs server-side for minutes and nothing pushes the outcome back, so
// a submitted result would sit at "In Progress" until the user reloaded. Poll
// while anything is still running, stop as soon as everything settles — and give
// up after the window, since a failed run can strand a result at "In Progress"
// indefinitely, which would otherwise poll for the whole session.
const POLL_MS = 15000;
const POLL_WINDOW_MS = 15 * 60 * 1000;

export const useResultList = (imageId: string) => {
    // The poll reason comes from the query's own data, so it has to be held in
    // state: the interval is read when the query hook runs, one render before
    // the data that justifies it can be inspected.
    const [runningKey, setRunningKey] = useState('');
    const pollingInterval = useCappedPolling(runningKey !== '', runningKey, POLL_MS, POLL_WINDOW_MS);
    const query = useListResultsQuery({ imageId }, { pollingInterval });

    // Keyed by which results are running, so submitting a new analysis after an
    // earlier one stalled restarts the give-up window instead of inheriting it.
    const nextKey = (query.data ?? [])
        .filter((result: any) => result?.status === 'In Progress' || result?.status === 'Synthesizing...')
        .map((result: any) => result.id)
        .sort()
        .join(',');
    useEffect(() => {
        setRunningKey(nextKey);
    }, [nextKey]);

    return query;
};
